export const RECURRENCE_FREQUENCIES = ['daily', 'weekly', 'monthly', 'yearly'] as const;

export type RecurrenceFrequency = typeof RECURRENCE_FREQUENCIES[number];

export interface RecurrenceValues {
  readonly freq?: RecurrenceFrequency;
  readonly tzid?: string;
  readonly hour?: number | number[];
  readonly weekday?: string[];
  readonly month?: number[];
  readonly setpos?: number;
  readonly week_number?: number;
  readonly month_day?: number;
  readonly year_day?: number;
}

export interface RecurrenceOccurrence {
  readonly key: string;
  readonly date: string;
  readonly time: number;
}

export interface RecurrenceRule {
  readonly ruleText: string;
  readonly occurrences: RecurrenceOccurrence[];
}

export interface StoredRecurrence extends Omit<RecurrenceValues, 'freq'> {
  readonly freq?: string;
}

export interface RecurrenceResultValues extends Omit<RecurrenceValues, 'hour'> {
  readonly hour?: number[];
}
